import Homev2 from "./Homev2";

export default Homev2;
